import React from 'react';
import { Button } from '@ncoder/ui';

interface ScenarioCardProps {
  title: string;
  description: string;
  onClick?: () => void;
}

export const ScenarioCard: React.FC<ScenarioCardProps> = ({
  title,
  description,
  onClick,
}) => {
  return (
    <Button 
      variant="outline" 
      className="h-auto p-4 justify-start" 
      onClick={onClick}
    >
      <div className="text-left">
        <p className="font-medium">{title}</p>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
    </Button>
  );
};
